module.exports = __webpack_public_path__ + "media/images/home/upcoming-event-bg-23facc34c2231c89aae9ece0df346240.png";